import React from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";

import { ButtonItem, Field, Segmant } from "../../components";

const Contact = ({
  formData,
  test,
  feild,
  onclick,
  mailsuccess,
  onchange,
  isdisable,
  ...props
}) => {
  return (
    <Segmant>
      <Form>
        {formData.map((feild, index) => (
          <>
            {feild.control === "Input" ? (
              <Field
                key={index}
                contrl={feild.control}
                value={feild.value}
                name={feild.name}
                {...props}
                placeholder={feild.placeholder}
                onChange={(e) => onchange(e, feild.value)}
              />
            ) : (
              <Field
                className="text_area_cnt"
                key={index}
                contrl={feild.control}
                //defaultValue={feild.value}
                value={feild.value}
                name={feild.name}
                {...props}
                placeholder="I am interested in buying or selling a home"
                onChange={(e) => onchange(e, feild.value)}
              />
            )}
            {index === 3 && (
              <ButtonItem
                fluid
                title="Send"
                className="btn_blue_bg"
                disabled={isdisable}
                onClick={(e) => onclick(e, feild.value)}
              />
            )}
          </>
        ))}
        {mailsuccess && (
          <p className="mail_success">Agent contacted successfully!</p>
        )}
      </Form>
    </Segmant>
  );
};

Contact.propTypes = {
  formData: PropTypes.any,
};

export default Contact;
